module.exports = __webpack_public_path__ + "static/media/img-1.eaa3c1b1.jpg";